import { render, staticRenderFns } from "./Contribuitions.vue?vue&type=template&id=2b3a27c5"
import script from "./Contribuitions.vue?vue&type=script&lang=js"
export * from "./Contribuitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports